<template>
    <content-view>
        <div slot="header">
            <table class="qz-form bg-white user-query-table">
                    <tbody>
                        <tr>
                            <td width="42"
                                class="table-cell-attr">姓名：</td>
                            <td>
                                <a-input></a-input>
                            </td>
                            <td width="42"
                                class="table-cell-attr">姓名：</td>
                            <td>
                                <a-input></a-input>
                            </td>
                            <td width="70"
                                class="table-cell-attr">姓时尚名：</td>
                            <td>
                                <a-input></a-input>
                            </td>
                        </tr>
                        <tr>
                            <td width="42"
                                class="table-cell-attr">姓名：</td>
                            <td>
                                <a-input></a-input>
                            </td>
                            <td class="text-left" colspan="4">
                                <a-button
                                          type="primary">submit</a-button>
                                <a-button class="ml8">reset</a-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
        </div>
        <div class="container bg-white">
            <div style="display: flex">
                <rich-text ref="rich" :list="viewerList"></rich-text>
                <rich-text-viewer :list="viewerList" class="ml32"></rich-text-viewer>
            </div>
        </div>

        <div @click="getData">获取内容</div>
    </content-view>
</template>

<script type="text/javascript">
import richText from '@/components/modules/rich-text.component'
import richTextViewer from '@/components/modules/rich-text-viewer.component'

export default {
    name: "component_name",
    components: {
        richText,
        richTextViewer
    },
    props: {},
    data() {
        return {
            viewerList: [
                {
                    type: 'text',
                    value: 'asdasd\nas\nd'
                },
                {
                    type: 'text',
                    value: 'asdasdasd'
                },
                {
                    type: 'text',
                    value: 'asdasdasd'
                },
                {
                    type: 'text',
                    value: 'asdasdasd'
                }
            ]
        };
    },
    computed: {},
    methods: {
        getData () {
            this.viewerList = this.$utils.deepClone(this.$refs.rich.getData());
        }
    },
    created() {
    },
    mounted() {}
}
</script>
<style lang="scss">
</style>